export const buildProfiles = profiles =>
    profiles.map((profile) => buildProfile(profile));

const buildProfile = (profile) => ({
    ...profile,
    displayName: `profiles:${profile.name.toLowerCase()}`
})